/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandSocketIo = createReactComponent("outline", "brand-socket-io", "IconBrandSocketIo", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 11h1l3 -4z", "key": "svg-1" }], ["path", { "d": "M12 13h1l-4 4z", "key": "svg-2" }]]);

export { IconBrandSocketIo as default };
//# sourceMappingURL=IconBrandSocketIo.mjs.map
